import { STAGE_SELECTION_SCOPE } from '@pearsontechnology/aero-stage-presentation-framework/dist/rce/constants';
import { STAGE_ELEMENT_TYPES } from 'pluginServices/editorState/constants';
import { PLUGIN_SCOPE } from 'constants/selectionScopes';
import { ACTIONS } from 'services/UndoRedoService/constants/undoRedo';
import { SECTION_MOVED_DOWN } from "./operations";

import activityService from 'services/ActivityService';
import pathwayService from 'services/PathwayService';
import interactiveService from 'services/InteractiveService';
import annotationService from "services/AnnotationService";
import { getPluginSchema } from 'data/Plugin/actions';
import { findPropertiesByScope } from '@pearsontechnology/aero-plugin-schema';
import { dispatch } from 'pluginServices/store';

export const computeSectionReselection = (action, eventType) => {
  if (eventType === ACTIONS.UNDO) {
    return action.data.operation === SECTION_MOVED_DOWN
      ? getSectionReselectionData({
        screenId: action.elementId,
        sectionIndex: action.data.newIndex - 1,
        stageRef: action.data.stageRef,
      })
      : getSectionReselectionData({
        screenId: action.elementId,
        sectionIndex: action.data.newIndex + 1,
        stageRef: action.data.stageRef,
      });
  } else if (eventType === ACTIONS.REDO) {
    return getSectionReselectionData({
      screenId: action.elementId,
      sectionIndex: action.data.newIndex,
      stageRef: action.data.stageRef,
    });
  }
};


const getSectionReselectionData = ({ screenId, sectionIndex, stageRef }) => ({
  path: [PLUGIN_SCOPE, screenId, ...STAGE_SELECTION_SCOPE],
  data: {
    selectedPath: [sectionIndex],
    type: STAGE_ELEMENT_TYPES.SECTION,
    stageRef,
  },
});

const moveComponents = async (components, componentIds, originalScreenId, destintationScreenId, originalScreenPathwayId, destinationScreenPathwayId) => {
  try {
    const originalScreenPathway = await pathwayService.getPathway(originalScreenPathwayId);
    const originalScreenActivity = await activityService.getActivity(originalScreenPathway?.parentActivityId);

    const destinationScreenPathway = await pathwayService.getPathway(destinationScreenPathwayId);
    const destinationScreenActivity = await activityService.getActivity(destinationScreenPathway?.parentActivityId);

    for (const componentId of componentIds) {
      await interactiveService.authorStudentScopeDeregister(
        originalScreenId,
        componentId,
        originalScreenActivity?.studentScopeURN
      );
    }

    for (let { _componentId, _pluginId, _pluginVersion } of components) {
      dispatch(
        getPluginSchema(_pluginId, _pluginVersion, async (schema) => {
          const learnerEditableProperties = findPropertiesByScope(schema);
          if (learnerEditableProperties.length) {
            // Register in the background since it's a slow request
            await interactiveService.authorStudentScopeRegister(
              destintationScreenId,
              _componentId,
              destinationScreenActivity?.studentScopeURN
            );
          }
        })
      );
    }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('error occured in moveComponents', e);
  }
  await interactiveService.moveInteractiveComponents(componentIds, destintationScreenId);
};

export const restoreAnnotationsAttached = async (annotations) => {
  await annotationService.authorAnnotationsRestore(annotations);
};

export const deleteAnnotationsAttached = async (annotations) => {
  await annotationService.authorAnnotationsDelete(annotations);
};

export const updateConfigs = async (originalScreenId, destinationScreenId, originalScreenConfig, destinationScreenConfig, originalScreenPathwayId, destinationScreenPathwayId, componentsData, componentIds) => {

  let originalScreenComponents = [];
  let destinationScreenComponents = [];
  destinationScreenComponents = originalScreenConfig?.components?.filter((componentInfo) => {
    if (componentIds.includes(componentInfo.itemId)) return true;

    originalScreenComponents.push(componentInfo);
    return false;
  }) || [];

  const { components = [] } = destinationScreenConfig;
  destinationScreenConfig.components = [...components, ...destinationScreenComponents];
  originalScreenConfig.components = [...originalScreenComponents];

  if (componentIds && componentIds.length > 0) {
    await moveComponents(componentsData, componentIds, originalScreenId, destinationScreenId, originalScreenPathwayId, destinationScreenPathwayId);
  }

  await interactiveService.saveInteractiveConfig(originalScreenId, originalScreenConfig);
  await interactiveService.saveInteractiveConfig(destinationScreenId, destinationScreenConfig);
};

// this function return empty valued object based on the object key type
export const createEmptyDataObj = (data) => Object.keys(data).reduce((accumulator, key) => {
  if (data[key] && typeof data[key] === 'object' && !Array.isArray(data[key])) {
    return { ...accumulator, [key]: createEmptyDataObj(data[key]) };
  } else if (typeof data[key] === 'string') {
    return { ...accumulator, [key]: '' };
  }

  return { ...accumulator };
}, {});

/**
 * updateConfigByKeypath is about updating the configs for other keypaths.
 * For Example: ['stepLabels'] for scrollmation nav screen. 
 */
export const updateConfigByKeypath = async (elementId, action, eventType) => {
  if (!action.data) return;
  
  const { previousData = null, currentData = null } = action.data;
  if (eventType === ACTIONS.UNDO && previousData) {
    await interactiveService.saveInInteractiveConfig(elementId, [previousData.title], previousData.config);
  } else if (eventType === ACTIONS.REDO && currentData) {
    await interactiveService.saveInInteractiveConfig(elementId, [currentData.title], currentData.config);
  }
};